<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<div class="listView">
			<div class="pageLeft">
				<!-- 日历组件 -->
				<div id="huotiCalendar">
					<el-calendar v-model="calendarValue">
						<template slot="dateCell" slot-scope="{date, data}">
							<div class="dateView">
								<div :class="data.isSelected ? 'is-selected' : ''" @click="handelSecectClick(date)" class="dateSpan">
									{{ data.day.split('-').slice(2).join('-') }}
								</div>
								<div v-for="(item,index) in errArr" :key="index">
									<div class="circle1" v-if="data.day == item.date && item.checkTimesStatus == 0"></div>
									<div class="circle2" v-if="data.day == item.date && item.exceptionStatus == 1"></div>
								</div>
							</div>
						</template>
					</el-calendar>
				</div>
				<!-- 宠物转移记录 -->
				<div class="petView">
					<div class="petTitle">转移记录</div>
					<div class="transList">
						<template v-if="transCount != 0">
							<div class="transItem" v-for="(item,index) in transList" :key="index">
								<div class="transCom mb12">
									<div class="transComName">转移人:{{item.transferUserName}}</div>
									<div>时间:{{FormatDateTime(item.operation_info.create.create_time)}}</div>
								</div>
								<div class="transCom">
									<div class="transComName">接收人:{{item.receiverUserName}}</div>
									<div>时间:{{FormatDateTime(item.receiverTime)}}</div>
								</div>
							</div>
						</template>
						<div class="noTrans" v-else>-暂无转移记录-</div>
					</div>
				</div>
			</div>
			<!-- 右侧页面 -->
			<div class="rightView">
				<!-- 头部 -->
				<div class="titleView" v-if="petInfo != null">
					<div class="imgView">
						<img :src="petInfo.cover == null?'':petInfo.cover" alt="">
					</div>
					<div class="msgView">
						<el-row style="margin-bottom: 20px;">
							<el-col :span="3" class="msgItem">
								<div>昵称</div>
								<div>{{petInfo.inside_name}}</div>
							</el-col>
							<el-col :span="3" class="msgItem">
								<div>品种</div>
								<div>{{petInfo.breed_info.name}}</div>
							</el-col>
							<el-col :span="2" class="msgItem">
								<div>种类</div>
								<div>{{petInfo.apply_type.title}}</div>
							</el-col>
							<el-col :span="2" class="msgItem">
								<div>性别</div>
								<div>{{petInfo.pet_sex}}</div>
							</el-col>
							<el-col :span="2" class="msgItem">
								<div>绝育</div>
								<div>{{petInfo.sterilization == 0?'未绝育':'已绝育'}}</div>
							</el-col>
							<el-col :span="2" class="msgItem">
								<div>状态</div>
								<div>{{petInfo.pet_status.title}}</div>
							</el-col>
							<el-col :span="2" class="msgItem">
								<div>年龄</div>
								<div>{{petInfo.age}}</div>
							</el-col>
							<el-col :span="2" class="msgItem">
								<div>体重</div>
								<div>{{petInfo.weight}}</div>
							</el-col>
							<el-col :span="2" class="msgItem">
								<div>颜色</div>
								<div>{{petInfo.color}}</div>
							</el-col>
							<el-col :span="4" class="msgItem">
								<div>备注</div>
								<div>{{petInfo.remark == null?'--':petInfo.remark }}</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="3" class="msgItem">
								<div>芯片编号</div>
								<div>{{petInfo.eprom_no == ''?'--':petInfo.eprom_no}}</div>
							</el-col>
							<el-col :span="3" class="msgItem">
								<div>脖圈号</div>
								<div>{{petInfo.inside_no == ''?'--':petInfo.inside_no}}</div>
							</el-col>
							<el-col :span="2" class="msgItem">
								<div>销售价</div>
								<div>{{petInfo.price}}</div>
							</el-col>
							<el-col :span="3" class="msgItem">
								<div>所在门店</div>
								<div>{{petInfo.feed_shop_name}}</div>
							</el-col>
							<el-col :span="2" class="msgItem">
								<div>检查次数</div>
								<div>{{petInfo.check_times}}次</div>
							</el-col>
							<el-col :span="2" class="msgItem">
								<div>异常次数</div>
								<div>{{petInfo.exception_times}}次</div>
							</el-col>
							<el-col :span="9" style="text-align: right;">
								<el-button type="primary" size="small" class="msgBtn" @click="handelAddGrowthClick">添加成长记录</el-button>
								<el-button type="primary" size="small" class="msgBtn" @click="handelEditClick" >编辑</el-button>
								<el-button type="primary" size="small" class="msgBtn" @click="handleLogClick">操作记录</el-button>
								<el-button type="primary" size="small" class="msgBtn" @click="handleBackClick">返回</el-button>
							</el-col>
						</el-row>
					</div>
				</div>
				<div class="rightViewB">
					<!-- 列表 -->
					<div class="lists">

						<div class="noGrowth" v-if="growthCount == 0"> -暂无成长记录- </div>
						<template v-else>
							<div class="dateItem">{{ForCalendar()}}</div>
							
							<div class="listItem" v-for="(item,index) in growths" :key="index">
								<img src="../../../assets/img/icon_PC.png" alt="" class="pcImg" v-if="item.source == 1">
								<div @click="handleItemClick(index)" :class="index == tabs?'active':'listItemTop'">
									<div class="m10">检查时间</div>
									<div class="f14 m10">{{FormatTime(item.operation_info.create.create_time)}}</div>
									<div class="m10">状态</div>
									<div class="f14" v-if="item.petStatus.value == '1'">正常</div>
									<div class="f14" v-if="item.petStatus.value == '0'">异常</div>
									<div class="f14" v-if="item.petStatus.value == '-1'">亡故</div>
								</div>
								<div class="listItemBot">
									<div @click="handelModifyClick(item)">修改</div>
									<div @click="handelHideClick(item,0)" v-if="item.status == 1">隐藏</div>
									<div @click="handelHideClick(item,1)" v-if="item.status == 0">显示</div>
									<div @click="handelHideClick(item,-1)">删除</div>
								</div>
							</div>
						</template>
					</div>
					<!-- 详情 -->
					<div class="detailView" v-if="growthCount != 0">
						<div class="detailViewTitle">内容</div>
						<div class="detailViewContent">{{detailData.titleContent}}</div>
						<div class="imgList">
							<el-image :src="item" :preview-src-list="FormatArrData(detailData.avatarPic)" v-for="(item,index) in FormatArrData(detailData.avatarPic)" :key="index" class="imgItem" fit="cover">
							</el-image>
						</div>
						<div class="detailViewTitle">位置</div>
						<div class="detailViewContent">{{detailData.roomName}}{{detailData.cageName}}</div>
						<div class="detailViewTitle">说明</div>
						<div class="detailViewContent">{{detailData.statusRemark == ''?'--':detailData.statusRemark}}</div>
						<div class="detailViewTitle">饮食记录</div>
						<div class="detailViewContent">{{detailData.dietRemark == ''?'--':detailData.dietRemark}}</div>
						<div class="detailViewTitle">备注</div>
						<div class="detailViewContent">{{detailData.remark == ''?'--':detailData.remark}}</div>
					
					</div>
					<div class="noDetailView" v-else>-暂无成长记录-</div>
				</div>
			</div>
			
		</div>
		<!-- 操作日志弹框 -->
		<div v-if="dialogLog_state">
			<dialogLog @closeOn="handleLogClose" :logState.sync="dialogLog_state" :shopId.sync="shopId" :petId.sync="petItem.petId"></dialogLog>
		</div>
		<!-- 成长记录弹框 -->
		<div v-if="dialogGrowth_state">
			<dialogGrowth @closeOn="handleGrowthClose" @closeClick="handleRearchClick" :growthState.sync="dialogGrowth_state" :shopId.sync="shopId" :petId.sync="petItem.petId" :growthType.sync="growthType" :growthItem.sync="growthItem"></dialogGrowth>
		</div>
		<!-- 编辑宠物弹框 -->
		<div v-if="dialogAddPet_state">
			<dialogAddPet @closeOn="handleAddPetClose" @closeClick="handelRearchClick" :addPetState.sync="dialogAddPet_state" :petInfo.sync="petInfo" :petType.sync="petType"></dialogAddPet>
		</div>
	</div>
</template>

<script>
	import {
		petCalendar,
		growthrecordlist,
		petTransferList,
		getPetInfo,
		hideGrowth
	} from "@/api/purchaseApi.js"
	import dialogLog from "../../../components/dialog_log.vue"
	import dialogGrowth from "../../../components/dialog_addGrowth.vue"
	import dialogAddPet from "../../../components/dialog_addPet.vue"
	export default {
		components: {
			dialogLog,
			dialogGrowth,
			dialogAddPet
		},
		data() {
			return {
				dialogAddPet_state:false, //编辑宠物弹框
				petItem: JSON.parse(this.$route.query.item),
				fixedHeight: '',
				shopId: this.$route.query.shopId,
				calendarValue: this.$route.query.calendarValue,
				errArr: [], //异常日历
				growths: [], //成长记录列表
				growthCount: 0, //成长记录列表数量
				tabs: 0, //切换
				detailData: null, //详情数据
				transList: [], //宠物转移记录
				transCount: 0, //宠物转移记录数量
				petInfo: null, //宠物信息
				dialogLog_state:false,  //操作记录弹框
				dialogGrowth_state:false, //成长记录弹框
				growthType:1,  //1是新增成长记录 2是修改成长记录
				growthItem:null,  //选中成长记录
				hideStatus:'',  //隐藏状态
				petType:'2',  //编辑宠物
			}
		},
		created() {
			this.$nextTick(() => {
				// 点击前一个月
				let prevBtn = document.querySelector(
					".el-calendar__button-group .el-button-group>button:nth-child(1)"
				);
				prevBtn.addEventListener("click", () => {
					this.getMonthData()
					this.getListData()
				});

				//点击下一个月
				let nextBtn = document.querySelector(
					".el-calendar__button-group .el-button-group>button:nth-child(3)"
				);
				nextBtn.addEventListener("click", () => {
					console.log(this.calendarValue);
					this.getMonthData();
					this.getListData()
				});

				//点击今天
				let todayBtn = document.querySelector(
					".el-calendar__button-group .el-button-group>button:nth-child(2)"
				);
				todayBtn.addEventListener("click", () => {
					this.getMonthData()
					this.getListData()
				});
			});
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
			this.getPetInfo()
			this.getMonthData();
			this.getListData();
			this.getTransList()
		},
		methods: {
			//修改后关闭宠物弹框
			handelRearchClick(val){
				this.dialogAddPet_state = val;
				this.getPetInfo();
			},
			//关闭编辑宠物弹框
			handleAddPetClose(val){
				this.dialogAddPet_state = val
			},
			//编辑宠物
			handelEditClick(){
				this.dialogAddPet_state = true;
			},
			//修改成长记录
			handelModifyClick(item){
				console.log(item)
				this.growthType = 2;
				this.growthItem = item;
				this.dialogGrowth_state = true;
			},
			//隐藏和删除成长记录
			handelHideClick(item,status){
				let params = {
					id:item._id,
					status:status
				}
				if(status == -1){
					this.$confirm('是否删除该条成长记录？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						hideGrowth(params).then((res)=>{
							console.log(res)
							if(res.code == 0){
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								this.getListData()
							}
						})
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});          
					});
				}else{
					hideGrowth(params).then((res)=>{
						console.log(res)
						if(res.code == 0){
							this.getListData()
						}
					})
				}
			},
			//新增成长记录按钮
			handelAddGrowthClick(){
				this.growthType = 1;
				this.growthItem = null;
				this.dialogGrowth_state = true;
			},
			//图片转数组
			FormatArrData(str){
				return str.split(",")
			},
			//获取操作记录
			handleLogClick(){
				this.dialogLog_state = true;
			},
			//关闭新增成长记录弹框
			handleGrowthClose(val){
				this.dialogGrowth_state = val
			},
			//关闭成长记录刷新
			handleRearchClick(val){
				this.dialogGrowth_state = val
				this.getPetInfo()
				this.getMonthData();
				this.getListData();
			},
			//关闭操作日志弹框
			handleLogClose(val){
				this.dialogLog_state = val
			},
			//获取宠物详情
			getPetInfo() {
				console.log('详情日历',new Date(this.calendarValue).getTime()/1000)
				let pamars = {
					petId: this.petItem.petId,
					time:new Date(this.calendarValue).getTime()/1000
				}
				getPetInfo(pamars).then((res) => {
					console.log('详情', res)
					if (res.code == 0) {
						this.petInfo = res.data;
					}
				})
			},
			//格式化完整日期
			FormatDateTime(time) {
				let times = new Date(time * 1000);
				let year = times.getFullYear();
				let month = (times.getMonth() + 1) < 10 ? '0' + (times.getMonth() + 1) : (times.getMonth() + 1);
				let day = times.getDate() < 10 ? '0' + times.getDate() : times.getDate();
				let hh = times.getHours() < 10 ? '0' + times.getHours() : times.getHours();
				let mm = times.getMinutes() < 10 ? '0' + times.getMinutes() : times.getMinutes();
				let ss = times.getSeconds() < 10 ? '0' + times.getSeconds() : times.getSeconds();
				return `${year}-${month}-${day} ${hh}:${mm}:${ss}`
			},
			//获取宠物转移记录
			getTransList() {
				console.log(this.petItem)
				let pamars = {
					petId: this.petItem.petId
				}
				petTransferList(pamars).then((res) => {
					console.log('转移记录',res)
					if (res.code == 0) {
						this.transList = res.data;
						this.transCount = res.data.length;
					}
				})
			},
			//获取当前选中日期
			ForCalendar() {
				let now = new Date(this.calendarValue);
				let year = now.getFullYear();
				let month = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
				let day = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
				return `${year}-${month}-${day}`
			},
			//点击成长记录
			handleItemClick(index) {
				this.tabs = index;
				this.detailData = this.growths[index];
				console.log(this.detailData)
			},
			//格式化时间
			FormatTime(time) {
				let times = new Date(time * 1000);
				let hh = times.getHours() < 10 ? '0' + times.getHours() : times.getHours();
				let mm = times.getMinutes() < 10 ? '0' + times.getMinutes() : times.getMinutes();
				let ss = times.getSeconds() < 10 ? '0' + times.getSeconds() : times.getSeconds();
				return `${hh}:${mm}:${ss}`
			},
			//选择日期
			handelSecectClick(date) {
				this.calendarValue = date;
				this.getListData();
				this.getPetInfo()
			},
			//获取成长记录列表
			getListData() {
				console.log(this.petItem)
				let now = new Date(this.calendarValue);
				let year = now.getFullYear();
				let month = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
				let day = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
				let startDateStr = `${year}-${month}-${day} 00:00:00`;
				let endDateStr = `${year}-${month}-${day} 23:59:59`;
				let startDate = new Date(startDateStr.replace(/-/g, '/')).getTime() / 1000;
				let endDate = new Date(endDateStr.replace(/-/g, '/')).getTime() / 1000;
				console.log(startDate, endDate)
				let pamars = {
					petId: this.petItem.petId,
					bgnDate: startDate,
					endDate: endDate
				}
				growthrecordlist(pamars).then((res) => {
					if (res.code == 0) {
						console.log('成长记录', res)
						if(res.data.length > 0){
							this.growths = res.data;
							this.growthCount = res.data.length;
							if (res.data.length != 0) {
								this.detailData = res.data[0];
							}
						}else{
							this.growths = [];
							this.growthCount = 0;
						}
						
					}
				})
			},
			//格式化日期
			formatDate(date) {
				let now = new Date(Number(date) * 1000);
				// console.log(now)
				let year = now.getFullYear();
				let month = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
				let day = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
				return `${year}-${month}-${day}`
			},
			//获取当前月
			getMonthData() {
				// console.log(this.calendarValue)
				let now = new Date(this.calendarValue);
				// console.log(now)
				let year = now.getFullYear();
				let month = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
				let temp = new Date(year, month, 0);
				let days = temp.getDate()
				let startDateStr = `${year}-${month}-01 00:00:00`;
				let endDateStr = `${year}-${month}-${days} 23:59:59`;
				// console.log(year,month,days,startDateStr,endDateStr)
				let startDate = new Date(startDateStr.replace(/-/g, '/')).getTime() / 1000;
				let endDate = new Date(endDateStr.replace(/-/g, '/')).getTime() / 1000;
				// console.log(startDate, endDate)
				let id = this.petItem._id;
				// console.log(id)
				let pamars = {
					startTime: startDate,
					endTime: endDate,
					shopId:this.shopId,
					petId: id
				}
				petCalendar(pamars).then((res) => {
					console.log(res)
					if (res.code == 0) {
						this.errArr = res.data
					}
				})
			},
			//返回按钮
			handleBackClick() {
				this.$router.back();
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		display: flex;
		flex-direction: column;
		.rightView{
			flex: 1;
			display: flex;
			flex-direction: column;
		}
		// 重复头部
		.titleView {
			// width: 100%;
			padding: 15px;
			font-size: 14px;
			background: #fff;
			margin-bottom: 20px;
			display: flex;
			align-items: center;
			.imgView{
				width: 110px;
				border: 1px solid rgba(0, 0, 0, 0.15);
				padding: 8px;
				border-radius: 2px;
				text-align: center;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-right: 20px;
				img{
					width: 94px;
					height: 94px;
				}
			}
			.msgView{
				flex: 1;
				.msgItem{
					div:nth-of-type(1){
						color: #626262;
						font-weight: bold;
						margin-bottom: 10px;
					}
					div:nth-of-type(1){
						color: #2A2A2A;
					}
				}
				.msgBtn{
					margin-right: 10px;
				}
			}
		}

		.pageLeft {
			margin-right: 14px;
			display: flex;
			flex-direction: column;

			.petView {
				color: #2A2A2A;
				flex: 1;
				background: #fff;
				display: flex;
				flex-direction: column;
				overflow-x: hidden;
				overflow-y: scroll;
				padding: 10px;

				.petTitle {
					font-size: 16px;
					font-weight: bold;
					text-align: center;
					line-height: 30px;
					border-bottom: solid 1px rgba(26, 26, 26, 0.19);
				}

				.transList {
					overflow-x: hidden;
					overflow-y: scroll;

					.transItem {
						font-size: 12px;
						color: rgba(0, 0, 0, 0.85);
						padding: 10px 0;
						border-bottom: solid 1px rgba(26, 26, 26, 0.19);

						.transCom {
							display: flex;
							justify-content: space-between;
							align-items: center;
							.transComName{
								width: 114px;
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
								line-height: 18px;
							}
						}

						.mb12 {
							margin-bottom: 12px;
						}
					}

					.noTrans {
						text-align: center;
						margin-top: 200px;
					}
				}

				.transList::-webkit-scrollbar {
					display: none;
				}
			}

			.petView::-webkit-scrollbar {
				display: none;
			}
		}
		.rightViewB{
			flex: 1;
			display: flex;
			
		}
		.listView {
			flex: 1;
			display: flex;

			.lists {
				width: 140px;
				display: flex;
				align-items: center;
				flex-direction: column;
				margin-right: 14px;
				.dateItem {
					width: 140px;
					padding: 10px 0;
					background: #fff;
					margin-bottom: 10px;
					text-align: center;
					font-weight: bold;
				}

				.listItem {
					width: 140px;
					height: 140px;
					background: #fff;
					display: flex;
					flex-direction: column;
					align-items: center;
					border-radius: 2px;
					margin-bottom: 10px;
					position: relative;
					.pcImg{
						width: 20px;
						height: 20px;
						position: absolute;
						right: 10px;
						top: 10px;
						z-index: 9;
					}
					.f14 {
						font-size: 14px;
					}
					.m10{
						margin-bottom: 10px;
					}
					.listItemTop{
						width: 140px;
						height: 110px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
					}
					.active {
						width: 140px;
						height: 110px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						background: #1890FF;
						color: #fff;
					}
					.listItemBot{
						flex: 1;
						line-height: 30px;
						display: flex;
						width: 100%;
						font-size: 14px;
						color: #fff;
						background: #C2C2C2;
						div{
							flex: 1;
							text-align: center;
						}
					}
				}
				

				.noGrowth {
					font-size: 14px;
					padding: 10px 0;
				}

				
			}

			.detailView {
				flex: 1;
				padding: 20px 30px;
				background: #fff;
				overflow-x: hidden;
				overflow-y: scroll;

				.detailViewTitle {
					font-size: 20px;
					color: #303030;
					font-weight: bold;
					margin-bottom: 10px;
				}

				.detailViewContent {
					font-size: 16px;
					color: #363636;
					margin-bottom: 30px;
				}
				.imgList{
					margin-bottom: 30px;
					.imgItem {
						width: 110px;
						height: 110px;
						margin-right: 14px;
					}
				}
			}

			.detailView::-webkit-scrollbar {
				display: none;
			}

			.noDetailView {
				flex: 1;
				padding: 20px 30px;
				background: #fff;
				text-align: center;
				font-size: 20px;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}

		.dateSpan {
			width: 100%;
			line-height: 30px;
			text-align: center;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.dateView {
			width: 100%;
			height: 100%;
			position: relative;

			.circle1 {
				width: 4px;
				height: 4px;
				position: absolute;
				left: 0;
				right: 0;
				bottom: 4px;
				background: #FCB300;
				border-radius: 50%;
				margin: 0 auto;
			}

			.circle2 {
				width: 4px;
				height: 4px;
				position: absolute;
				left: 0;
				right: 0;
				bottom: 4px;
				background: #03BF23;
				border-radius: 50%;
				margin: 0 auto;
			}

		}
	}
</style>
